import React from "react";
import PDFHeaderV from "../../PDFHeaderV/PDFHeader";

const ROWS_NUMBER = 12;

// Using a class component, everything works without issue
export class IntervenantsPDF extends React.PureComponent {
    render() {
        return (
            <div className="PDFValidateurContent">
                <div className="recommandationsPDF">
                    <h1 className="titrePDF">V - INTERVENANTS</h1>

                    <div
                        style={{
                            marginLeft: "50px",
                            marginRight: "50px",
                            marginTop: "40px",
                        }}
                    >
                        <table className="table table-bordered table-sm align-middle">
                            <thead className="theadValidation">
                                <tr>
                                    <th scope="col">INTERVENANTS</th>
                                    <th scope="col" style={{ width: "70px" }}>
                                        DATE
                                    </th>
                                    <th scope="col" style={{ width: "150px" }}>
                                        EE/ES
                                    </th>
                                    <th scope="col" style={{ width: "150px" }}>
                                        POINTAGE
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from(Array(ROWS_NUMBER), (e, i) => {
                                    return (
                                        <tr key={i}>
                                            <th style={{ height: "65px" }}></th>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="pagebreak"></div>
            </div>
        );
    }
}
